<template>
  <div>
    <v-container>
      <v-btn @click="back" text class="text_btn">
        <v-icon>keyboard_arrow_left</v-icon>back
      </v-btn>
      <h1>Functions ({{ p_name }})</h1>
      <br />
      <v-expansion-panels style="margin-top:30px;">
        <FunctionsCard @functionUpdated="loadAll" v-for="f in functions" :f="f" :key="f.id"></FunctionsCard>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <i style="max-width:20px;" class="fal fa-plus"></i>
            <span>New function</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form @submit="addFunction">
              <v-text-field label="Name" v-model="new_name"></v-text-field>
              <v-textarea label="Description" v-model="new_description"></v-textarea>
              <v-btn type="submit">Add</v-btn>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>

<script>
import { Functions } from "../../logic/Functions";
import { Notifications } from "../../notification";
import { Projects } from "../../logic/Projects";
import FunctionsCard from "../../components/functions/FunctionCard";

export default {
  name: "FunctionsOverview",
  data() {
    return {
      p_name: "...",
      project_id: 0,
      functions: [],

      new_name: "",
      new_description: "",
    };
  },
  mounted() {
    this.project_id = this.$route.params.project_id;
    this.loadProjectMeta(this.project_id);
    this.loadAll();
  },
  methods: {
    async loadProjectMeta(project_id) {
      var project_response = await Projects.get(project_id);
      if (project_response.status === 200) {
        if (Array.isArray(project_response.body) && project_response.body.length > 0) {
          this.p_name = project_response.body[0].name;
        } else if (project_response.body && project_response.body.name) {
          this.p_name = project_response.body.name;
        }
      }
    },
    async loadAll() {
      var response = await Functions.load(this.project_id);
      if (response.status === 200) {
        this.functions = response.body;
      }
    },
    async addFunction(e) {
      e.preventDefault();
      var response = await Functions.add(
        this.project_id,
        this.new_name,
        this.new_description
      );
      if (response.status === 200) {
        Notifications.show("The function has been added.");
        this.loadAll();
        this.new_name = "";
        this.new_description = "";
      } else {
        Notifications.show(response.message);
      }
    },
    back() {
      this.$router.replace("/project/" + this.project_id);
    },
  },
  components: {
    FunctionsCard
  }
};
</script>

<style>
</style>